import Vue from 'vue'

export function requireAuth (to, from, next) {
  const authService = Vue.auth
  if (!authService) {
    throw new Error(
      'AuthService not installed! Make sure to call `Vue.use(AuthService)`.',
    )
  }

  authService.initProc.then(() => {
    if (!authService.isAuthenticated) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      })
    } else {
      next()
    }
  })
}

export function skipIfAuth (to, from, next) {
  const authService = Vue.auth
  if (!authService) {
    throw new Error(
      'AuthService not installed! Make sure to call `Vue.use(AuthService)`.',
    )
  }

  authService.initProc.then(() => {
    if (authService.isAuthenticated) {
      next('/')
    } else {
      next()
    }
  })
}
